import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import EpisodesCategory from "@/pages/category/episodes/page";
import ActorsCategory from "@/pages/category/actors/page";
import PlotsCategory from "@/pages/category/plots/page";
import EpisodeDetail from "@/pages/detail/EpisodeDetail";
import ActorDetail from "@/pages/detail/ActorDetail";
import PlotDetail from "@/pages/detail/PlotDetail";
import SearchResult from "@/pages/search/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/episodes", element: <EpisodesCategory /> },
      { path: "category/actors", element: <ActorsCategory /> },
      { path: "category/plots", element: <PlotsCategory /> },
      { path: "detail/episode/:id", element: <EpisodeDetail /> },
      { path: "detail/actor/:id", element: <ActorDetail /> },
      { path: "detail/plot/:id", element: <PlotDetail /> },
      { path: "search", element: <SearchResult /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;